import { render, staticRenderFns } from "./fundSdxDialog.vue?vue&type=template&id=5ffdf1b4"
import script from "./fundSdxDialog.vue?vue&type=script&lang=js"
export * from "./fundSdxDialog.vue?vue&type=script&lang=js"
import style0 from "./fundSdxDialog.vue?vue&type=style&index=0&id=5ffdf1b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports